import React from "react";
import { useTranslation } from "react-i18next";
import { Sparkles } from "lucide-react";
import { useAssistant } from "../../contexts/AssistantContext";

/**
 * Phase 4A.5A — the shell entry point. A button, and nothing else.
 *
 * It owns no conversation, no request and no open/closed state. `AssistantProvider`
 * owns all of it from above `<Routes>`, because this component is inside
 * `<Layout>` and every page renders its own `<Layout>` — navigating replaces
 * this button, and a conversation that lived here would go with it.
 *
 * The node registers itself with the provider so focus can return to whichever
 * launcher is currently on the page when the dialog closes.
 *
 * Rendered only inside `Layout`, which renders only inside `<Guarded>`. There
 * is no unauthenticated path to it.
 */
export default function AssistantLauncher() {
  const { t } = useTranslation();
  const assistant = useAssistant();
  if (!assistant) return null;

  const { open, toggle, registerLauncher } = assistant;
  return (
    <button
      type="button"
      className="qw-assistant-launcher"
      onClick={toggle}
      aria-label={t(open ? "assistant.close" : "assistant.open")}
      aria-expanded={open}
      aria-haspopup="dialog"
      data-testid="assistant-launcher"
      ref={registerLauncher}
    >
      <Sparkles size={18} strokeWidth={2} aria-hidden="true" />
    </button>
  );
}
